import {Injectable, Inject} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
    YoutubeVideo, YoutubeChannel, YoutubeVideoDetails,
    YouTubeApiSearchResponseItem, YouTubeApiSearchResponse, YouTubeApiVideoSearchResponse
} from "../../modele/social-media/youtubeModels";
import {NGXLogger} from "ngx-logger";

// GET https://www.googleapis.com/youtube/v3/search?channelId=UChl3h_bqcx_c15f7WOtSn-A&key=[YOUR_API_KEY] HTTP/1.1
// GET https://www.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=dxFex73cPBA&key=[YOUR_API_KEY] HTTP/1.1

//GET https://www.googleapis.com/youtube/v3/videos?part=statistics&id=dxFex73cPBA&key=[YOUR_API_KEY] HTTP/1.1

// export const YOUTUBE_API_KEY = 'AIzaSyAUlLa3gpA7eTg62QwxNlrSYi9OuMHUJfs';
//export const YOUTUBE_API_KEY = 'AIzaSyB5pS_pceYxBqpL0SQsRtnghvOQTBSmEuk';

export const YOUTUBE_API_KEY = 'AIzaSyBDgPJmamJ-Ydza9cKoxadx2THYgedG81o';

export const YOUTUBE_API_URL = 'https://www.googleapis.com/youtube/v3/search';
export const YOUTUBE_API_URL2 = 'https://www.googleapis.com/youtube/v3/channels';
export const YOUTUBE_API_URL3 = 'https://www.googleapis.com/youtube/v3/playlistItems';


@Injectable({
    providedIn: 'root'
})
export class YoutubeService {
    log_prefix = this.constructor.name + ":";

    constructor(private http: HttpClient,
                @Inject(YOUTUBE_API_KEY) private apiKey: string,
                @Inject(YOUTUBE_API_URL) private apiUrl: string,
                @Inject(YOUTUBE_API_URL2) private apiUrl2: string,
                @Inject(YOUTUBE_API_URL3) private apiUrl3: string,
                private logger:NGXLogger
    ) {
    }

    search(query: string): Observable <YoutubeChannel[] > {
        let lp=this.log_prefix+"search:";
        const params = `part=snippet&maxResults=10&q=${query}&key=${this.apiKey}`;
        const queryUrl = `${this.apiUrl}?${params}`;

        return new Observable<YoutubeChannel[]>((observer) => {
            return this.http.get<YouTubeApiSearchResponse>(queryUrl).subscribe(resp => {

                let dings = new YouTubeApiSearchResponse(resp);
                let {items} = dings;
                let parsedYouTubeChannelList = items.map(item => {
                    let {snippet} = item;
                    let {id} = item;
                    let {kind} = id;
                    let {channelId} = snippet;
                    let {thumbnails} = snippet;
                    let {title} = snippet;
                    let {medium} = thumbnails;
                    let {url} = medium;
                    if(kind == "youtube#channel"){
                        let createdYouTubeChannel= new YoutubeChannel({channelId, channelTitle: title, thumbnails:url});
                        return createdYouTubeChannel;
                    }
                }).filter(ele => ele != null);
                return observer.next(parsedYouTubeChannelList);
            });
        });
    }

    getVideosFromYoutube(query: string): Observable <YoutubeVideo[] > {
        let lp=this.log_prefix+"getVideosFromYoutube:";
        const params = `key=AIzaSyAUlLa3gpA7eTg62QwxNlrSYi9OuMHUJfs&channelId=${query}&part=snippet&order=date&maxResults=50`;
        const queryUrl = `${this.apiUrl}?${params}`;


        return new Observable<YoutubeVideo[]>((observer)=>{

            this.http.get<YouTubeApiVideoSearchResponse>(queryUrl).subscribe(resp => {
                let parsedResp = new YouTubeApiVideoSearchResponse(resp)
                let {items} = parsedResp;

                let parsedYouTubeVideoList = items.map(item => {
                    let {id} = item;
                    let {videoId} = id;
                    let {snippet} = item;
                    let {channelId} = snippet;
                    let {thumbnails} = snippet;
                    let {description} = snippet;
                    let {title} = snippet;
                    let {publishTime} = snippet;
                    let {high} = thumbnails;
                    let {url} = high;
                    let createdYouTubeVideo = new YoutubeVideo({
                        id: videoId,
                        title: title,
                        description: description,
                        thumbnailUrl: url,
                        publishTime: publishTime,
                        videoId: videoId,
                    });
                    return createdYouTubeVideo;
                });
                observer.next(parsedYouTubeVideoList);
            });
        });


        // return this.http.get(queryUrl).map((response: Response) => {
        //     return (<any>response.json()).items.map(item => {
        //         return new YoutubeVideo({
        //             id: item.id.videoId,
        //             title: item.snippet.title,
        //             description: item.snippet.description,
        //             thumbnailUrl: item.snippet.thumbnails,
        //             publishTime: item.snippet.publishTime,
        //             videoId: item.id.videoId,
        //         });
        //     });
        // });
    }

    getVideosForYoutubeChannel(query: string): Observable <any[] > {
        let lp=this.log_prefix+"getVideosFromYoutube:";
        const params = `key=AIzaSyAUlLa3gpA7eTg62QwxNlrSYi9OuMHUJfs&id=${query}&part=contentDetails`;
        const queryUrl = `${this.apiUrl2}?${params}`;
        return new Observable<any[]>((observer) => {
            // let list : VimeoChannel[] = [];
            this.http.get(queryUrl).subscribe(resp => {
                let data = resp['items'];
                observer.next(data);
            });
        });
    }
    getVideosDetailsForYoutubeChannel(query: string): Observable <any[] > {
        let lp=this.log_prefix+"getVideosFromYoutube:";
        const params = `key=AIzaSyAUlLa3gpA7eTg62QwxNlrSYi9OuMHUJfs&playlistId=${query}&part=snippet&maxResults=50`;
        const queryUrl = `${this.apiUrl3}?${params}`;
        return new Observable<any[]>((observer) => {
            // let list : VimeoChannel[] = [];
            this.http.get(queryUrl).subscribe(resp => {
                let data = resp['items'];
                observer.next(data);
            });
        });
    }

    // https://www.googleapis.com/youtube/v3/playlistItems?playlistId=UUoIhpDdM2m2UObWI9K__gdg&key=AIzaSyAUlLa3gpA7eTg62QwxNlrSYi9OuMHUJfs&part=snippet&maxResults=50

    //todo: needs fixing
    getVideosDetails(query: string): Observable <YoutubeVideoDetails[] > {

        let lp=this.log_prefix+"getVideosDetails:";
        const params = `part=snippet%2CcontentDetails%2Cstatistics&id=${query}&key=AIzaSyAUlLa3gpA7eTg62QwxNlrSYi9OuMHUJfs`;
        const queryUrl = `${this.apiUrl2}?${params}`;
        // return this.http.get(queryUrl).map((response: Response) => {
        //     return (<any>response.json()).items.map(item => {
        //         return new YoutubeVideoDetails({
        //             id: item.id,
        //             dislikeCount: item.statistics.dislikeCount,
        //             likeCount: item.statistics.likeCount,
        //             viewCount: item.statistics.viewCount,
        //             date: item.snippet.publishedAt
        //         });
        //     });
        // });
        return new Observable((observer)=>{
            observer.next([]);
        })
    }
}
